const QUERY = gql`
  query BuySellOrderEmailQuery($slug: String!) {
    buySellOrder(slug: $slug) {
      id
      slug
      customer {
        id
        name
      }
      customerContact {
        id
        name
        email
      }
      vendor {
        id
        name
      }
      vendorContact {
        id
        name
        email
      }
      customerPo
      vendorSo
      customerSalesTerms
      vendorSalesTerms
      orderDate
      shipment {
        id
        shipDate
        deliveryDate
        freightCompany {
          id
          name
        }
        terms
        customFields
      }
      subsidiary {
        id
        description
      }
      customFields
    }
  }
`;

export default { QUERY };
